import {
  COMMO_DEFAULT_LANGUAGE,
  type CommoLanguage,
  isCommoLanguage,
} from './supported-languages';

/**
 * ブラウザ等の言語タグを公式対応コードへ寄せる。
 * 例: pt / pt-PT → pt-BR、zh / zh-Hans → zh-CN、zh-TW → en（繁体未対応）
 */
export function normalizeAppLanguage(
  raw: string | null | undefined,
): CommoLanguage {
  if (!raw?.trim()) {
    return COMMO_DEFAULT_LANGUAGE;
  }

  const tag = raw.trim().replace(/_/g, '-');
  if (isCommoLanguage(tag)) {
    return tag;
  }

  const lower = tag.toLowerCase();
  const primary = lower.split('-')[0] ?? lower;

  if (primary === 'pt') {
    return 'pt-BR';
  }

  if (primary === 'zh') {
    if (
      lower.includes('hant') ||
      lower.endsWith('-tw') ||
      lower.endsWith('-hk')
    ) {
      return COMMO_DEFAULT_LANGUAGE;
    }
    return 'zh-CN';
  }

  const byPrimary: Record<string, CommoLanguage> = {
    en: 'en',
    ja: 'ja',
    es: 'es',
    de: 'de',
    fr: 'fr',
    it: 'it',
    nl: 'nl',
    pl: 'pl',
    tr: 'tr',
    ko: 'ko',
    id: 'id',
    vi: 'vi',
    cs: 'cs',
    uk: 'uk',
    ru: 'ru',
  };

  return byPrimary[primary] ?? COMMO_DEFAULT_LANGUAGE;
}
